import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Accessibility, Visibility } from '../../models/container.types';

@Component({
    selector: 'app-container-collaboration-settings',
    templateUrl: './container-collaboration-settings.component.html',
    styleUrls: ['./container-collaboration-settings.component.scss'],
    standalone: false,
})
export class ContainerCollaborationSettingsComponent {
    @Input() visibilityOptions: Visibility[] = [];
    @Input() accessibilityOptions: Accessibility[] = [];
    @Input() selectedVisibility: Visibility;
    @Input() selectedAccessibility: Accessibility;

    @Output() visibilityChange = new EventEmitter<Visibility>();
    @Output() accessibilityChange = new EventEmitter<Accessibility>();

    onVisibilityChange(option: Visibility): void {
        this.visibilityChange.emit(option);
    }

    onAccessibilityChange(option: Accessibility): void {
        this.accessibilityChange.emit(option);
    }
}
